import React from 'react';

interface DemoBankLogoProps {
  width?: number;
  height?: number;
  color?: string;
}

const DemoBankLogo: React.FC<DemoBankLogoProps> = ({ 
  width = 40, 
  height = 40, 
  color = '#1e3a8a' 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 100 100" 
      fill="none"
    >
      {/* Shield background */}
      <path 
        d="M50 5L20 20V45C20 65 35 80 50 95C65 80 80 65 80 45V20L50 5Z" 
        fill={color}
        stroke={color === '#ffffff' ? '#1e3a8a' : 'none'}
        strokeWidth={color === '#ffffff' ? '1' : '0'}
      />
      
      {/* Bank building inside shield */}
      <g transform="translate(50, 50)">
        {/* Building base */}
        <rect 
          x="-15" 
          y="-5" 
          width="30" 
          height="20" 
          fill={color === '#ffffff' ? '#1e3a8a' : '#ffffff'}
          rx="2"
        />
        
        {/* Pillars */}
        <rect x="-12" y="-5" width="3" height="20" fill={color === '#ffffff' ? '#1e3a8a' : '#d97706'} />
        <rect x="-6" y="-5" width="3" height="20" fill={color === '#ffffff' ? '#1e3a8a' : '#d97706'} />
        <rect x="0" y="-5" width="3" height="20" fill={color === '#ffffff' ? '#1e3a8a' : '#d97706'} />
        <rect x="6" y="-5" width="3" height="20" fill={color === '#ffffff' ? '#1e3a8a' : '#d97706'} />
        <rect x="12" y="-5" width="3" height="20" fill={color === '#ffffff' ? '#1e3a8a' : '#d97706'} />
        
        {/* Roof/Triangle */}
        <path 
          d="M-18 -5L0 -15L18 -5L15 -5L0 -12L-15 -5Z" 
          fill={color === '#ffffff' ? '#1e3a8a' : '#d97706'}
        />
        
        {/* Steps */}
        <rect 
          x="-18" 
          y="15" 
          width="36" 
          height="3" 
          fill={color === '#ffffff' ? '#1e3a8a' : '#64748b'}
        />
        <rect 
          x="-16" 
          y="18" 
          width="32" 
          height="2" 
          fill={color === '#ffffff' ? '#1e3a8a' : '#64748b'}
        />
      </g>
    </svg>
  );
};

export default DemoBankLogo; 